import { useEffect, useState } from 'react';
import { getSessionUser, onAuthChange, isSignedInUser } from '../lib/authAccount';

// Lecture seule de l'etat de session, pour les surfaces qui ont juste besoin de
// savoir s'il y a un compte derriere l'utilisateur. useAccountAuth porte tout le
// formulaire d'inscription et exige le DataProvider ; le monter pour un booleen
// serait disproportionne.
export function useSignedIn() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let active = true;
    getSessionUser().then((u) => {
      if (active) setUser(u);
    });
    const unsubscribe = onAuthChange((u) => {
      if (active) setUser(u);
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return { user, signedIn: isSignedInUser(user) };
}

export default useSignedIn;
